import React from "react"
import styled from "styled-components"

import {injectIntl, InjectIntl, FormattedMessage} from "@irati/utils/lang"
import Link from "@irati/ui/src/Link"

const StyledLink = styled(Link)`
  &:hover,
  &:focus {
    text-decoration: none;
    box-shadow: none;
  }
`

const HelpEmail: React.FC<InjectIntl> = (props) => {
  const {formatMessage} = props
  return (
    <StyledLink cta href={formatMessage({id: "medical.landing.contactCard.email.mailto"})} marginBottom={1} marginLeft={1} target="_blank">
      <FormattedMessage id="medical.landing.contactCard.email.text" />
    </StyledLink>
  )
}

export default injectIntl(HelpEmail)
